import {GroupedSizeFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterFlyoutSizeGrouped} from '@aboutyou/ui-components';
import React from 'react';
import {useGroupedSizeFilterSection} from '../../shared/useGroupedSizeFilterSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: GroupedSizeFilterSection;
  hide: VoidFunction;
  isOpen: boolean;
  open: (sections: string[]) => void;
  submit: VoidFunction;
  resetFilter: (slug: string) => void;
  resetFilters: (slug: string[]) => void;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    singleSelectOnly?: boolean;
  }) => void;
  enableFlyoutFilter: boolean;
};

export const FilterSectionSizeGrouped: React.FC<Props> = ({
  activeFilters,
  data,
  hide,
  isOpen,
  open,
  resetFilter,
  resetFilters,
  setFilter,
  enableFlyoutFilter,
  submit,
}) => {
  const {normalizedContent, handleSetSizeFilter, handleTabClick} =
    useGroupedSizeFilterSection({
      data,
      setFilter,
      resetFilters,
    });

  return (
    <FilterFlyoutSizeGrouped
      activeFilters={activeFilters}
      content={normalizedContent}
      hide={hide}
      isOpen={isOpen}
      onTabsReset={resetFilter}
      onSizeClick={handleSetSizeFilter}
      onTabClick={handleTabClick}
      open={open}
      submit={submit}
      enableFlyoutFilter={enableFlyoutFilter}
    />
  );
};
